import { Link } from "react-router-dom";

export default function YogaSchedule () {
    return (
        <>
        <div className="min-h-screen">
            <div className="relative">
            {/* <img
                src={require("./images/reversed_warrior.jpeg")}
                alt="Yoga in Arizona"
                className="w-full  object-cover"
            /> */}
            <div className="bg-[#57562A] h-96"></div>

             <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-2/3 w-full text-center text-[#ECB0FF] text-4xl">
                SCHEDULE
            </div>
        </div>
        <div className="text-[#735449] pb-10">
        <div className="text-center mt-10 ">
            <h1 className="text-xl">MONDAY</h1>
            <Link
            to="https://mindbodylove.com/schedule"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">6:30AM</p>
            <p className="underline">Vinyasa Yoga (45 Minutes)</p>
            </Link>
            <Link
            to="https://popflow.com/schedule/?_mt=%2Fschedule%2Fdaily%2F48541%3FactiveCategoryId%3D0%26locations%3D48717&ref=http%3A%2F%2Flocalhost%3A3000%2F"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">8:30AM</p>
            <p className="underline">Vinyasa Yoga (60 Minutes)</p>
            </Link>

            </div>
            <div className="text-center mt-10">
            <h1 className="text-xl">TUESDAY</h1>
            <Link
            to="https://popflow.com/schedule/?_mt=%2Fschedule%2Fdaily%2F48541%3Flocations%3D48718"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">8:30AM</p>
            <p className="underline">Mat Pilates (60 Minutes)</p>
            </Link>

            </div>
            <div className="text-center mt-10">
            <h1 className="text-xl">WEDNESDAY</h1>
            <Link
            to="https://southpark.yoga/schedule"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">8:30AM</p>
            <p className="underline">Mat Pilates (60 Minutes)</p>
            </Link>
            <Link
            to="https://popflow.com/schedule/?_mt=%2Fschedule%2Fdaily%2F48541%3Flocations%3D48718"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">12PM</p>
            <p className="underline">Power Flow (60 Minutes)</p>
            </Link>
            </div>


            <div className="text-center mt-10">
            <h1 className="text-xl">THURSDAY</h1>
            <Link
            to="https://mindbodylove.com/schedule"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">6:30AM</p>
            <p className="underline">Vinyasa Yoga (45 Minutes)</p>
            </Link>
             <Link
            to="https://mindbodylove.com/schedule"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">9AM</p>
            <p className="underline">Mat Pilates (60 Minutes)</p>
            </Link>
            <Link
            to="https://popflow.com/schedule/?_mt=%2Fschedule%2Fdaily%2F48541%3FactiveCategoryId%3D0%26locations%3D48717&ref=http%3A%2F%2Flocalhost%3A3000%2F"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">12PM</p>
            <p className="underline">Mat Pilates(60 Minutes)</p>
            </Link>

            </div>
            <div className="text-center mt-10">
            <h1 className="text-xl">FRIDAY</h1>
            <Link
            to="https://southpark.yoga/schedule"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">8:30AM</p>
            <p className="underline">Mat Pilates (60 Minutes)</p>
            </Link>
            <Link
            to="https://popflow.com/schedule/?_mt=%2Fschedule%2Fdaily%2F48541%3Flocations%3D48718"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">4:30PM</p>
            <p className="underline">Vinyasa Yoga (60 Minutes)</p>
            </Link>

            </div>

            <div className="text-center mt-10">
            {/* <h1 className="text-xl">SATURDAY</h1>
            <Link
            to="https://mindbodylove.com/schedule"
            className="flex justify-center items-center space-x-2"
            >
            <p className="text-lg">8AM</p>
            <p className="underline">Vinyasa Yoga (60 Minutes)</p>
            </Link> */}
            {/* <Link
            to="https://sinainfluxyoga.setmore.com/classes/ea9e0268-6e6c-402a-93b4-964b6324c365"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">10AM</p>
            <p className="underline">Nature Flow (60 Minutes)</p>
            </Link> */}

            </div></div>

        </div>

        </>
    )
}
